export const el = {
    LEFT: 'Αριστερά: μετάβαση στην προηγούμενη μέρα.',
    RIGHT: 'Δεξιά: Μετακίνηση στην επόμενη μέρα.',
    DOWN: 'Κάτω: Μετακίνηση στην επόμενη γραμμή.',
    UP: 'Πάνω: Μετακίνηση στην προηγούμενη γραμμή.',
    PGUP: 'PgUp: Μετακινήστε τον προηγούμενο μήνα.',
    PGDOWN: 'PgDown: Μετακίνηση στον επόμενο μήνα.',
    HOME: 'Το σπίτι: Μετακίνηση στο προηγούμενο έτος.',
    END: 'Τέλος: να Προχωρήσουμε στο επόμενο έτος.',
    ESC: 'Esc/Σήμερα/close: Κλείσιμο του ημερολογίου.',
    TITLE: 'Πληκτρολόγιο Οδηγίες'
};
